module.exports = __webpack_public_path__ + "img/audit.4fa6fae9.png";